import {
  ODataHeader,
  ODataString,
  ODataDate,
  ODataBoolean,
} from "pbas-vue-components";
import { translate } from "../trans";
import store from "@/store";
import { translate2 } from "../trans2";

const MemberGroupsHeaders = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("IdentityId"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    version: 1,
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/LanguageCode"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "Has History",
    type: new ODataBoolean("Identity/HasHistory"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    title: "globals.name",
    type: new ODataString("Name"),
    sortable: true,
    visible: false,
    allowVisibilityChange: false,
    searchable: true,
    version: 1,
  }),
  new ODataHeader({
    title: "globals.name",
    type: new ODataString("Translations[]/Name", {
      getString: (item) => translate2(item, "Name"),
      additionalKeys: [new ODataString("Name")],
    }),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
    version: 1,
    orderByKey: "Name",
  }),
  new ODataHeader({
    title: "OwnId",
    type: new ODataString("Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.description",
    type: new ODataString("Description"),
    sortable: true,
    visible: false,
    allowVisibilityChange: false,
    searchable: true,
    version: 1,
  }),
  new ODataHeader({
    title: "globals.description",
    type: new ODataString("Translations[]/Description", {
      getString: (item) => translate2(item, "Description"),
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
          type.getString(item, type) +
          "</div>"
        );
      },
      additionalKeys: [new ODataString("Description")],
    }),
    sortable: true,
    visible: true,
    searchable: true,
    version: 1,
    orderByKey: "Description",
  }),
  new ODataHeader({
    title: "globals.kind",
    type: new ODataString("Kind"),
    sortable: true,
    visible: false,
    allowVisibilityChange: false,
    searchable: true,
    version: 1,
  }),
  new ODataHeader({
    title: "globals.kind",
    type: new ODataString("Translations[]/Kind", {
      getString: (item) => translate2(item, "Kind"),
      additionalKeys: [new ODataString("Kind")],
    }),
    sortable: true,
    visible: true,
    searchable: true,
    version: 1,
    orderByKey: "Kind",
  }),
  new ODataHeader({
    title: "globals.order",
    type: new ODataString("Order"),
    visible: true,
    sortable: true,
    searchable: true,
    orderByKey: "Order"
  }),
  new ODataHeader({
    type: new ODataString(
      "CoverageIdentities[]/Current/Translations[]/LanguageCode"
    ),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.coverage",
    type: new ODataString("CoverageIdentities[]/Current/Translations[]/Name", {
      getString: (item) => {
        return item.CoverageIdentities.map((o) =>
          translate2(o.Current, "Name")
        ).join(", ");
      },
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
          type.getString(item, type) +
          "</div>"
        );
      },
      additionalKeys: [new ODataString("CoverageIdentities[]/Current/Name")],
    }),
    sortable: true,
    visible: true,
    searchable: true,
    version: 1,
  }),
  new ODataHeader({
    type: new ODataString("CoverageIdentities[]/Current/Name"),
    sortable: false,
    visible: false,
    searchable: true,
    version: 1,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "globals.status",
    type: new ODataString("Status/Name", {
      getString: (item) => {
        if (!item) return "";
        const lang = store.getters["common/language"];
        return translate(item.Status, lang.language);
      },
    }),
    sortable: true,
    visible: false,
    searchable: true,
    allowVisibilityChange: false,
    version: 1,
  }),
  new ODataHeader({
    type: new ODataString("Status/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.status",
    type: new ODataString("Status/Translations[]/DisplayValue", {
      getString: (item) => {
        if (!item) return "";
        const lang = store.getters["common/language"];
        return translate(item.Status, lang.language);
      },
      additionalKeys: [new ODataString("Status/Name")],
    }),
    visible: true,
    searchable: true,
    sortable: true,
    orderByKey: "Status/Name",
    version: 1,
  }),
  new ODataHeader({
    title: "Status Id",
    type: new ODataString("Status/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "StatusId",
    type: new ODataString("StatusId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "components.inmemorydependants.effective_date",
    type: new ODataDate("EffectiveDate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];
export default MemberGroupsHeaders;
